import React, { Fragment, useState, useEffect, useContext, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Radio } from 'antd';
import * as ROUTES from '../constants/routes';
import * as ROLES from '../constants/roles';
import { StoreContext } from '../containers/Store';
import './Activity.css';

const RadioGroup = Radio.Group;

const genUniqueId = () => {
  return '_' + Math.random().toString(36).substr(2, 9);
};

const Message = ({ message, activityWidth }) => {
  const [width, setWidth] = useState(null);
  useEffect(() => {
    (message.length*10 > activityWidth) ? setWidth(activityWidth) : setWidth(message.length*10);
  }, [message, window.innerWidth])

  const messageWithBold = message.split('@').map((frag, index) => {
    if (index % 2 !== 0) {
      return <span style={{ fontWeight: 'bold'}}>{frag}</span>
    } else {
      return frag
    }
  });

  const messageClean = (typeof messageWithBold === 'string') ? messageWithBold.split('$').map((frag, index) => {
    if (index % 2 !== 0) {
      return <span style={{ fontWeight: 'bold'}}>{frag}</span>
    } else {
      return frag
    }
  }) : messageWithBold.map(frag => (typeof frag === 'string') ? frag.split('$').map((f, index) => {
    if (index % 2 !== 0) {
      return <em>{f}</em>
    } else {
      return f
    }
  }) : frag);

  console.log(messageClean[0][0], messageClean[0][0].includes('📖'));

  return (
    <div
      className={(!!messageClean &&
        messageClean.length > 0 &&
        !!messageClean[0] &&
        messageClean[0].length > 0 &&
        messageClean[0][0].includes('📖')) ? 'instruction-bubble' : 'message-bubble'}
      style={{
        width: width,
        marginBottom: '20px',
      }}>
      { messageClean }
    </div>
  )
}

const Answer = ({ answer, activityWidth }) => {
  const [width, setWidth] = useState(null);
  useEffect(() => {
    (answer.length*10 > activityWidth) ? setWidth(activityWidth) : setWidth(answer.length*10 + 20);
  }, [answer, window.innerWidth]);
  return (
    <div className='message-bubble right'
      style={{
        width: width,
        minWidth: '70px',
        alignSelf: 'flex-end',
        backgroundColor: 'rgb(86, 152, 252)',
        color: 'white',
      }}
    >
      { [...answer]
          .map(letter => {
            if (letter === '[') {
              return <span style={{ fontWeight: 'bold'}}> [ </span>
            } else if (letter === ']') {
              return <span style={{ fontWeight: 'bold'}}> ] </span>
            } else if (letter === '/') {
              return <span style={{ fontWeight: 'bold'}}>/</span>
            } else {
              return letter
            }
          })
      }
    </div>
  )
}

const QCM = ({
  content,
  getAnswer,
}) => {
  const [answer, setAnswer] = useState();
  const onChange = (e) => {
    setAnswer(content[e.target.value]);
    getAnswer(content[e.target.value], e.target.value);
  }
  return (
    <div
      style={{
        position: 'relative',
        left: '20px',
      }}
    >
      {
        !answer && 
        <RadioGroup
          onChange={onChange}
          value={answer}
          style={{
            marginLeft: '30px',
            marginBottom: '20px', 
            maxWidth: '50%',
            display: 'block',
            height: '60px',
            lineHeight: '30px',
          }}
        >
          {content.map((choice, i) =>
            <Radio value={i} key={genUniqueId()}>
              {[...choice]
                .map(letter => {
                  if (letter === '[') {
                    return <span style={{ fontWeight: 'bold'}}> [ </span>
                  } else if (letter === ']') {
                    return <span style={{ fontWeight: 'bold'}}> ] </span>
                  } else if (letter === '/') {
                    return <span style={{ fontWeight: 'bold'}}>/</span>
                  } else {
                    return letter
                  }
                })
              }
            </Radio>)}
        </RadioGroup>
      }
    </div>
  );
}

const ButtonAction = ({ text, onClick }) => 
  <Button
    style={{
      maxWidth: '150px',
      position: 'relative',
      left: '40%',
      marginBottom: '20px',
      marginTop: '15px',
      paddingTop: '8px',
      paddingBottom: '12px',
      textAlign: 'center'
    }}
    onClick={onClick}
    type="primary"
    size="large"
  >
    {text}
  </Button>;


const Choice = ({
  content,
  getChoice,
}) => {
  const onClick = (value) => {
    getChoice(content[value]);
  }
  return (
    <Fragment>
      { 
        !!content && content.length > 0 &&
        <div
          buttonStyle="solid"
          style={{
            maxWidth: (window.innerWidth < 520) ? '150px' : '300px',
            display: 'flex',
            justifyContent: 'space-between',
            position: 'relative',
            left: Math.floor((window.innerWidth - 200)*0.22),
            marginTop: '20px',
            marginBottom: '20px'
          }}
        >
          {content.map((choice, i) =>
            <Button
              onClick={() => onClick(i)}
              type="primary"
              size="large"
              key={genUniqueId()} > {choice} </Button>)}
        </div>
      }
    </Fragment>
  )
}

const Sequence = ({ activityWidth, activityHeight, localActivityId, history }) => {
  const {
    content: { content: cont },
    sequence: { sequence: seq, storeSequence },
    tracking: { answers: ans, storeAnswers, activityId: actId },
    user: { user },
  } = useContext(StoreContext);
  
  let { content } = cont;
  if (!content) content = [];
  let { sequence } = seq;
  if (!sequence) sequence = [];
  let { answers } = ans;
  if (!answers) answers = [];
  let { activityId } = actId;
  if (!activityId) activityId = 0;

  useEffect(()=> {
    scrollToBottom();
  });

  useEffect(() => {
    const lastContent = sequence[sequence.length-1];
    if (
      content &&
      content.length > 0 &&
      (
        !lastContent ||
        lastContent &&
        content[0].content !== lastContent.content &&
        user.roles.includes(ROLES.STUDENT_DEMO) &&
        (
          content[0].type !== "choice" ||          
          (
            lastContent.content === "Je pense que vous avez compris. On change d'entraînement ?" || // choice only if preceded by correct feedback
            lastContent.content === "Entraînement terminé ! On passe au suivant ?"
          )
        ) ||
        user.roles.includes(ROLES.TEACHER_DEMO) &&
        (
          content[0].type !== "choice" && content[0].type !== "button" &&
            (
              content[0].type === "feedback" && !lastContent.content.includes("Je décèle") ||
              content[0].type !== "feedback"
            )
        )
      )
    ) {
      const contentCopy = JSON.parse(JSON.stringify(content));
      storeSequence({ sequence: [...sequence, ...contentCopy], token: user.token });
      scrollToBottom();
    }
  }, [content]);

  const onClick = () => {
    sequence[sequence.length-1].type = "answer";
    storeSequence({ sequence: [...sequence], token: user.token });
    scrollToBottom();
    const answer = sequence[sequence.length-1];
    answer.tms = Date.now();
    storeAnswers({
      answers: [...answers, answer],
      token: user.token
    });    
  }

  const getAnswer = (a, i) => {
    sequence[sequence.length-1].content = a;
    sequence[sequence.length-1].type = "answer";
    const isCorrect = () => {
      const rawCorrectAnswer = sequence[sequence.length-1].correct_answer;
      console.log(rawCorrectAnswer);
      const cleanCorrectAnswer = (rawCorrectAnswer && rawCorrectAnswer.length > 1) ?
        Array.from(rawCorrectAnswer
          .substr(1, rawCorrectAnswer.length-2)
          .split("||")).map(str => parseInt(str)) :
        parseInt(rawCorrectAnswer);
      return (cleanCorrectAnswer.length) ?
        cleanCorrectAnswer.includes(i+1) : cleanCorrectAnswer === i+1;
    };
    storeSequence({ sequence: [...sequence], token: user.token });
    const answer = sequence[sequence.length-1];
    answer.isCorrect = isCorrect();
    answer.tms = Date.now();
    answer.activity = activityId;
    scrollToBottom();
    storeAnswers({
      answers: [...answers, answer],
      token: user.token
    });
  }

  const getChoice = (a) => {
    sequence[sequence.length-1].content = a;
    sequence[sequence.length-1].type = "answer";
    const answer = sequence[sequence.length-1];
    answer.tms = Date.now();
    answer.isCorrect = null;
    storeAnswers({
      answers: [...answers, answer],
      token: user.token
    });
    storeSequence({ sequence: [...sequence], token: user.token });
    if (a === "Au suivant !") { history.push({ pathname: ROUTES.CHATBOT, state: activityId })}
    scrollToBottom();
  }

  const messagesEnd = useRef(null);

  const scrollToBottom = () => {
    if (!!messagesEnd) messagesEnd.current.scrollIntoView();
  }

  return (
      <div 
        style={{ 
        width: (window.innerWidth < 520) ? '300px' : `${activityWidth}px`,
        margin: 'auto', 
        flex: '1 1 90%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        alignItems: 'top',
        backgroundColor: "rgb(240, 242, 244)",
        height: activityHeight,
      }}>
        { sequence &&
          sequence
            .filter((e) => e.activity === localActivityId )
            .map((e) => {
              if (e.type === "message") {
                return <Message
                  message={e.content}
                  key={genUniqueId()}
                  activityWidth={activityWidth}
                />
              } else if (e.type === "feedback") {
                return <Message
                  message={e.content}
                  key={genUniqueId()}
                  activityWidth={activityWidth}
                />
              }
              else if (e.type === "button") {
                return <ButtonAction
                  text={e.content}
                  onClick={onClick}
                  key={genUniqueId()}
                /> 
              } else if (e.type === "qcm") {
                const cleanContent = Array.from(e.content
                  .substr(1, e.content.length-2)
                  .split("||"));
                return <QCM
                  content={cleanContent}
                  getAnswer={getAnswer}
                  key={genUniqueId()}
                />
              } else if (e.type === "choice") {
                return <Choice
                  content={e.content}
                  getChoice={getChoice}
                  key={genUniqueId(e)}
                />
              } else if (e.type === "answer") {
                return <Answer
                  answer={e.content}
                  key={genUniqueId(e)}
                  activityWidth={activityWidth}
                />
              }
            })
        }
        <div style={{ float:"left", clear: "both" }}
          ref={messagesEnd}>
        </div>
      </div>
  );
}

const Activity = (props) => <Sequence {...props} />;


export default withRouter(Activity);
